import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getPresentationInterval } from "../redux/selectors";
import Presentation from "./presentation";
const mapStateToProps = (state) => ({
    interval: getPresentationInterval(state)
});
const mapDispatchToProps = (dispatch) => ({
    onSetInterval: (interval) => dispatch(actionCreators.setPresentationInterval(interval))
});
export default connect(mapStateToProps, mapDispatchToProps)(Presentation);
